export default ({ get, put, post, checkStatus, toJSON }) => ({
  getAgeGroups: () =>
    get("universe/v1/age_groups").then(checkStatus).then(toJSON),

  updateCurriculumSettings: ({ curriculumId, ageGroupId }) =>
    put("universe/v1/classroom_curriculum_settings", {
      body: {
        curriculumId,
        ageGroupId,
      },
    }).then(checkStatus),

  getCurriculum: (id) =>
    get(`universe/v1/curriculums/${id}`).then(checkStatus).then(toJSON),

  getCompetency: (id) =>
    get(`universe/v1/competencies/${id}`).then(checkStatus).then(toJSON),

  getElement: (id) =>
    get(`universe/v1/elements/${id}`).then(checkStatus).then(toJSON),

  completeElement: (id) =>
    post(`universe/v1/classroom_element_completions`, {
      body: { elementId: id },
    }).then(checkStatus),

  submitPoll: (id, selections) =>
    post(`universe/v1/classroom_poll_option_selections`, {
      body: { elementId: id, pollOptionSelections: selections },
    }).then(checkStatus),
});
